import { Box, Button, Card, CardContent, Typography, Divider } from "@mui/material";
import React, { useState } from "react";
import GiftIcon from "../icons/GiftIcon";
import PointsHistory from "./PointsHistory";

const LevelProfile = ({ puntos }) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Card sx={{ borderRadius: "20px", boxShadow: "0 4px 20px rgba(0,0,0,0.05)", height: "100%" }}>
        <CardContent sx={{ p: 4, display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", height: "100%", justifyContent: "center" }}>

          <Box sx={{
            p: 3,
            borderRadius: "50%",
            backgroundColor: "rgba(128, 31, 85, 0.05)",
            mb: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}>
            <GiftIcon width={80} />
          </Box>

          <Typography variant="h3" fontWeight="bold" color="#801F55" sx={{ mb: 1 }}>
            {Number(puntos) || 0}
          </Typography>

          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Puntos Acumulados
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ mb: 4, maxWidth: "250px" }}>
            ¡Suma puntos en cada compra y canjéalos por increíbles recompensas!
          </Typography>

          <Button
            variant="contained"
            fullWidth
            onClick={handleClickOpen}
            sx={{
              backgroundColor: "#801F55",
              borderRadius: "12px",
              py: 1.5,
              textTransform: "none",
              fontWeight: "bold",
              boxShadow: "0 4px 12px rgba(128, 31, 85, 0.3)",
              "&:hover": { backgroundColor: "#601540" },
            }}
          >
            Ver Historial
          </Button>
        </CardContent>
      </Card>

      <PointsHistory open={open} handleClose={handleClose} />
    </>
  );
};

export default LevelProfile;
